import { render, staticRenderFns } from "./UnsubscribeRequestPopup.vue?vue&type=template&id=002f660f&scoped=true&"
import script from "./UnsubscribeRequestPopup.vue?vue&type=script&lang=ts&"
export * from "./UnsubscribeRequestPopup.vue?vue&type=script&lang=ts&"
import style0 from "./UnsubscribeRequestPopup.vue?vue&type=style&index=0&id=002f660f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "002f660f",
  null
  
)

export default component.exports